import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TUserType, adaptUserTypeFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_USERS_TYPES } from '../../backend-paths';


export const userTypeDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_USERS_TYPES}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_USERS_TYPES}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptUserTypeFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserType> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userTypeDeleteSlice = createSlice({
	name: 'userTypeDeleteSlice',
	initialState,
	reducers: {
		clearUserTypeDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userTypeDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userTypeDeleteApi.fulfilled.type]: (state, action: PayloadAction<TUserType>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userTypeDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserTypeDeleteSelector = () => useAppSelector(state => state[userTypeDeleteSlice.name]);

export const { clearUserTypeDelete } = userTypeDeleteSlice.actions;
